// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LogoutOutlinedSvg from "@fishx/icons-svg/es/asn/LogoutOutlined";
import FishxIcon from '../components/FishxIcon';

var LogoutOutlined = function LogoutOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LogoutOutlinedSvg
  }));
};

LogoutOutlined.displayName = 'LogoutOutlined';
export default React.forwardRef(LogoutOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LogoutOutlined.js
// module id = 3076
// module chunks = 0